import { MFieldsFlat, MFieldsNested } from '../types/MField';

export const nestMFields = (mFieldsFlat: MFieldsFlat): MFieldsNested => {
  const mFieldsNested: MFieldsNested = {};
  const addressDetailsKey: string = 'addressDetails';
  const addressDetailsKeys: string[] = ['street', 'houseNumber'];

  const taxIdentifierStoreKeys: string[] = [
    'taxIdentifierId',
    'taxIdentifierType',
  ];
  const taxIdentifierKey: string = 'taxIdentifier';
  const taxIdentifierKeysMap = {
    taxIdentifierId: 'id',
    taxIdentifierType: 'type',
  };

  Object.keys(mFieldsFlat).forEach((key) => {
    if (addressDetailsKeys.includes(key)) {
      if (!mFieldsNested[addressDetailsKey]) {
        mFieldsNested[addressDetailsKey] = {};
      }
      mFieldsNested[addressDetailsKey][key] = mFieldsFlat[key];
    } else if (taxIdentifierStoreKeys.includes(key)) {
      if (!mFieldsNested[taxIdentifierKey]) {
        mFieldsNested[taxIdentifierKey] = {};
      }
      const resultKey = taxIdentifierKeysMap[key];
      mFieldsNested[taxIdentifierKey][resultKey] = mFieldsFlat[key];
    } else {
      mFieldsNested[key] = mFieldsFlat[key];
    }
  });

  // TODO: Remove this when server switches form using 'holderId' to 'taxIdentifier'
  if (
    (!mFieldsNested.taxIdentifier || !mFieldsNested.taxIdentifier.id) &&
    mFieldsFlat.holderId
  ) {
    mFieldsNested.taxIdentifier = {
      id: mFieldsFlat.holderId,
    };
  }

  return mFieldsNested;
};
